var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-menu',{ref:"contextMenu",attrs:{"position-x":_vm.x,"position-y":_vm.y},model:{value:(_vm.isShow),callback:function ($$v) {_vm.isShow=$$v},expression:"isShow"}},[_c('v-list',[_vm._t("default",null,null,{item: _vm.item})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }